import { ModalFooter, ModalFooterButton } from '@/components/Modal'

import { useController } from '../../../hooks/useController'
import { useControllerActions } from '../../../hooks/useControllerActions'
import { useTexts } from '../../../useTexts'

type Props = {
  acknowledgeModal: () => void
}

export function SimulationWarningFooter(props: Props) {
  const { acknowledgeModal } = props
  const texts = useTexts()

  const { navigateToTerritorySettings } = useControllerActions()
  const { status, close } = useController()

  const submitting = status === 'submitting'

  const onClose = () => {
    acknowledgeModal()
    close?.()
  }

  const onNavigate = () => {
    acknowledgeModal()
    navigateToTerritorySettings()
  }

  return (
    <ModalFooter
      primaryAction={
        <ModalFooterButton
          testid="modal-secondary-button"
          data-trackid="modal-secondary-button"
          disabled={submitting}
          loading={submitting}
          onClick={onClose}
          variant="contained"
        >
          {texts.closeButton}
        </ModalFooterButton>
      }
      secondaryAction={
        <ModalFooterButton
          onClick={onNavigate}
          disabled={submitting}
          loading={submitting}
          testid="modal-primary-button"
          data-trackid="modal-primary-button"
        >
          {texts.navigateToTerritorySettingsButton}
        </ModalFooterButton>
      }
    />
  )
}
